import type { AxisLocation } from '../../AxisAndGrid/Axis/Axis.types';

export type ZoomViews = Partial<Record<AxisLocation, { identity: string; domain: [number, number] }>>;
export type ZoomHistory = { context: string; past: ZoomViews[]; present: ZoomViews; future: ZoomViews[] };
export type ZoomAction = { context: string } & (
  { type: 'commit'; views: ZoomViews } | { type: 'undo' | 'redo' | 'clear' }
);
export const createZoomHistory = (context: string): ZoomHistory => ({ context, past: [], present: {}, future: [] });

export const zoomHistoryReducer = (state: ZoomHistory, action: ZoomAction): ZoomHistory => {
  const current = state.context === action.context ? state : createZoomHistory(action.context);
  if (action.type === 'clear') return createZoomHistory(action.context);
  if (action.type === 'commit') {
    if (JSON.stringify(current.present) === JSON.stringify(action.views)) return current;
    return { ...current, past: [...current.past, current.present], present: action.views, future: [] };
  }
  if (action.type === 'undo' && current.past.length) {
    return { ...current, past: current.past.slice(0, -1), present: current.past[current.past.length - 1],
      future: [current.present, ...current.future] };
  }
  if (action.type === 'redo' && current.future.length) {
    return { ...current, past: [...current.past, current.present], present: current.future[0], future: current.future.slice(1) };
  }
  return current;
};
